export default "__VITE_ASSET__CUHeLKlQ__"